<template>
  <div
    id="app"
    :style="{
      'background-color': project.backgroundColor,
    }"
    class="height-100"
  >
    <router-view />
    <vue-snotify />
  </div>
</template>
<script>
export default {
  data() {
    return {
      project: {
        backgroundColor: '#000',
      },
      projectDomain: 'havenshousesi.org',
    };
  },
  created() {
    let domain = location.host;
    if (domain.split('.')[0] === 'www') {
      domain = domain.split('.');
      domain.shift();
      domain = domain.join('.');
    }
    this.projectDomain = domain;
    // this.getProject();
  },
  methods: {
    getProject() {
      this.axios.get(`${this.$API}/projects?domain=${this.projectDomain}`).then((response) => {
        if (response.data < 1) {
          this.projectDomain = 'havenshousesi.org';
          this.getProject();
        }
        this.project = response.data[0];
        this.getSteps();
      });
    },
  },
};
</script>
<style lang="scss">
@import "~vue-wysiwyg/dist/vueWysiwyg.css";
html,
body,
#app {
  background-color: #000;
  overflow: hidden !important;
  height: 100%;
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  // overflow-y: hidden !important;
  color: #2c3e50;
  a {
    color: #957513;
    font-weight: 600;
    text-decoration: none;
  }

  .tabs li.is-active a {
    border-bottom-color: #957513;
  }
}
</style>
